// @flow
export const OLD_ADMIN_URL =
  process.env.REACT_APP_OLD_ADMIN_URL || 'https://api.gotandem.co/aliadadmin';

export const SUPPORTED_BROWSERS =
  process.env.REACT_APP_SUPPORTED_BROWSERS || 'chrome';
